// extracted by mini-css-extract-plugin
export default {"notes":"ListNotesTab_notes__Y2mvW","table":"ListNotesTab_table__m0LDp"};